import aclEntityApi from '../../aclEntities/services/api'

export default {
  namespaced: true,
  actions: {
    getDomains: async function ({ commit }, payload) {
      return await aclEntityApi.getDomains(payload).then(response => response.data)
    },
    getPermissions: async function ({ commit }, payload) {
      return await aclEntityApi.getPermissions(payload).then(response => response.data)
    },
    getItems ({ commit }, payload) {
      return aclEntityApi.getItems({ ...payload, expand: 'permission,domain' })
        .then(response => ({
          items: response.data.items,
          totalCount: response.data.count
        }))
    },
 },
}
